<template>
<div class="school-notice card">
  <router-link :to="{name: 'AnnouncementDetails', params: {id: announcement.id }}">
    <h3>{{ announcement.title }}</h3>
    <span>{{ announcement.createdAt.toDate().toLocaleDateString('en-us', dateOptions) }}</span>
    <p>{{ snippet }}</p>
  </router-link>
</div>
</template>

<script>
import { computed, ref } from '@vue/reactivity'
export default {
  props: ['announcement'],
  setup (props) {
    const dateOptions = ref({ year: 'numeric', month: 'short', day: 'numeric' })
    const snippet = computed(() => {
      return props.announcement.content.substring(0, 100) + '... '
    })
    return { snippet, dateOptions }
  }
}
</script>

<style>
.school-notice {
  padding: 10px;
}
.school-notice h3 {
  color: #276749;
}
.school-notice a {
  text-decoration: none;
}
.school-notice a p, span {
  color: whitesmoke;
}
</style>
